import React from 'react'

const Shirt = ({width="23",height="22"}) => (
    <svg width={width} height={height} viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.245 1C14.245 1 13.1772 1.375 11.5 1.375C9.82281 1.375 8.755 1 8.755 1C8.58627 1 8.41875 1.02853 8.25953 1.08437L1 3.625L1.77953 7.75L4.07078 8.00875C4.35137 8.0405 4.60976 8.17662 4.79464 8.39007C4.97952 8.60352 5.07737 8.87869 5.06875 9.16094L4.75 20.5H18.25L17.9313 9.16094C17.9226 8.87869 18.0205 8.60352 18.2054 8.39007C18.3902 8.17662 18.6486 8.0405 18.9292 8.00875L21.2205 7.75L22 3.625L14.7405 1.08437C14.5812 1.02853 14.4137 1 14.245 1Z" stroke="#7F56D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

)
export default Shirt